<template>
<transition name="slide-fade">
  <nav aria-label="menus" :style="zIndex">
    <div class="logo">
      <span class="img-logo" aria-label="Apple Mango"></span>
    </div>
    <ul v-if="dynamicMenu !== null">
      <li v-for="(menu) in dynamicMenu"  :class="{active: menu.active}" :key="menu.url" @click="clickMenu(menu)" :aria-label="menu.url">
        <a>
          <div :class="['nav-menu', menu.menuIcon, {active: menu.active}]">
          </div>
        </a>
      </li>
    </ul>
    <span v-if="isAdmin && settingMenu !== null" class="nav-setting" aria-label="global setting">
      <a :title="settingMenu.menuName" @click="openSettingPopup">
        <div class="icons">
          <i class="fas fa-cog"></i>
        </div>
        <span>{{settingMenu.menuName}}</span>
      </a>
    </span>
    <w-settings v-if="isAdmin" ref="settingsPopup"></w-settings>
  </nav>
</transition>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
import forEach from 'lodash/forEach';
import cloneDeep from 'lodash/cloneDeep';
import MenuDefine from '@/constants/menu';
import userApi from '@/api/frame/user';
import { startRoutePathHistHandlerTimer, clearRoutePathHistHandlerTimer } from '@/utils/router';
import WSettings from '@/views/settings';

const defaultMenuUrl = MenuDefine.DASHBOARD;

export default {
  name: 'WFrameMenu',
  components: {
    WSettings,
  },
  data() {
    return {
      selectedMenu: null,
      dynamicMenu: null,
      settingMenu: null,
      /**
       * 라우트 경로 이력 핸들러 타이머
       * @type {Number}
       */
      routePathHistHandlerTimer: null,
    };
  },
  computed: {
    zIndex() {
      return {
        zIndex: this.$store.state.common.showFullscreenLayer || this.$store.state.common.showSettingView ? 50 : 2147483647,
      };
    },
    isAdmin() {
      const userInfo = this.$store.getters.userInfo;
      return !isEmpty(userInfo) && userInfo.managerType === 'ADMIN';
    },
    rootMenuInfo() {
      return this.$store.getters.rootMenuInfo;
    },
  },
  watch: {
    /**
     * 라우트 path에 따라 메뉴 변경 여부를 확인하여 변경된 경우 변경된 메뉴가 활성화되도록 처리한다.
     * @author Ju
     * @param  {object} to   변경 후 라우트 객체
     * @param  {object} from 변경 전 라우트 객체
     */
    $route(to, from) {
      if (!isEmpty(this.rootMenuInfo)) {
        const toMenu = to.path.split('/')[1];
        const fromMenu = from.path.split('/')[1];

        if (toMenu !== fromMenu) {
          console.info('------------------------------------- 1. Menu -------------------------------------------------');
          console.info(`change route from (${from.path}) : ${from.path.split('/')[1]} / ${from.params.treeKey} / ${from.params.activeTab}`);
          console.info(`change route To (${to.path}): ${to.path.split('/')[1]} / ${to.params.treeKey} / ${to.params.activeTab}`);
          console.info('------------------------------------------------------------------------------------------');
          const menu = this.findMenuByUrl(toMenu);
          if (!isEmpty(this.dynamicMenu) && isEmpty(menu)) {
            this.clickMenu(this.findMenuByUrl(defaultMenuUrl)); // 선택된 메뉴가 없을 경우 기본 메뉴가 선택되도록함.
          } else {
            this.changeSelectedMenu(menu);
          }
        }
      }
    },
    selectedMenu(to, from) {
      if (!isEmpty(to) && (isEmpty(from) || to.url !== from.url)) {
        userApi.insertMenuHist(to.managetypeId, to.menuId);
      }
    },
    rootMenuInfo: {
      immediate: true,
      handler(to) {
        if (!isEmpty(to)) {
          const currentMenuId = this.$route.path.split('/')[1];
          const menuInfo = cloneDeep(to);

          const dynamicMenu = [];
          let settingMenu = null;
          let selectedMenu = null;
          // data 객체에 할당 전 active 필드 추가
          forEach(menuInfo, (menu) => {
            menu.active = false;
            if (currentMenuId === menu.url) {
              selectedMenu = menu;
            }
            if (menu.menuId === 'SETTING') {
              settingMenu = menu;
            } else {
              dynamicMenu.push(menu);
            }
          });

          // data객체 할당
          this.dynamicMenu = dynamicMenu;
          this.settingMenu = settingMenu;

          if (isEmpty(selectedMenu)) {
            this.$nextTick(() => {
              this.clickMenu(this.findMenuByUrl(defaultMenuUrl)); // 선택된 메뉴가 없을 경우 기본 메뉴가 선택되도록함.
            });
          } else {
            this.changeSelectedMenu(selectedMenu);
          }
        }
      },
    },
  },
  /**
   * 동적/고정/설정 메뉴 데이터를 설정하고 라우트에 설정된 메뉴가 활성화되도록 한다.
   * @author Ju
   */
  created() {
    this.$store.dispatch('loadMenuInfo');
  },
  beforeDestory() {
    clearRoutePathHistHandlerTimer(this.routePathHistHandlerTimer);
  },
  methods: {
    /**
     * 클릭한 메뉴 기준으로 라우팅한다.
     * 메뉴 depth에 맞게 라우팅 처리하며, 3dpeth라도 activeTab은 유지하지 않는다.
     * @author Ju
     * @param  {object} menu 클릭한 메뉴의 데이터 객체
     */
    clickMenu(menu) {
      if (menu.url !== this.selectedMenu.url) {
        this.$store.dispatch('setActiveTab', null);
        this.$store.dispatch('setTmpActiveTab', null);
        const url = menu.url;
        if (menu.menuDepth === 1) {
          this.$nextTick(() => {
            this.$router.push({
              path: `/${url}`,
            });
          });
          this.$store.dispatch('setSelectedNode', null);
          this.$store.dispatch('setSelectedNodePath', null);
        } else {
          let path;
          let treeKey;
          const routeParams = this.$route.params;

          if (isEmpty(routeParams.treeKey)) {
            path = `/${url}`;
            this.$store.dispatch('setSelectedNode', null);
            this.$store.dispatch('setSelectedNodePath', null);
          } else {
            path = `/${url}/${routeParams.treeKey}`;
            treeKey = routeParams.treeKey;
          }

          let params = {
            treeKey,
          };

          if (url === 'topologymap') {
            path = '/topologymap';
            params = {};
          }

          this.$router.push({
            path,
            params,
          });
        }
      }
    },
    /**
     * 현재 라우트에 설정된 메뉴 ID의 메뉴 데이터 객체를 찾아 반환한다.
     * @author Ju
     * @param  {string} menuId 라우트에 설정된 메뉴 ID
     * @return {object}        메뉴 ID의 메뉴 데이터 객체
     */
    findMenuByUrl(url) {
      let selectedMenu = null;
      this.dynamicMenu.forEach((menu) => {
        if (url === menu.url) {
          selectedMenu = menu;
        }
      });

      return selectedMenu;
    },
    /**
     * 선택된 메뉴를 활성화하고 store에 설정한다.
     * @author Ju
     * @param  {[type]} menu [description]
     * @return {[type]}      [description]
     */
    changeSelectedMenu(menu) {
      if (isEmpty(this.selectedMenu)) {
        menu.active = true;
      } else if (this.selectedMenu.url !== menu.url) {
        this.selectedMenu.active = false;
        menu.active = true;
      }
      this.selectedMenu = menu;
      this.$store.dispatch('setSelectedMenu', menu);

      if (this.selectedMenu.menuDepth === 1) {
        // FIXME Ju 19.12.05 추후 메뉴 depth에 따라 초기화되어야하는 항목 function 별도 생성 및 공통화 필요
        this.$store.dispatch('setTreeMenu', null);
        this.$store.dispatch('setTreeType', null);
        this.$store.dispatch('setSelectedNode', null);
        this.$store.dispatch('setSelectedNodePath', null);
        this.$store.dispatch('setActiveTab', null);
        clearRoutePathHistHandlerTimer(this.routePathHistHandlerTimer);
        this.routePathHistHandlerTimer = startRoutePathHistHandlerTimer(this, this.$route.path);
      }
      return menu;
    },
    /**
     * 설정 팝업을 연다.
     * @author Ju
     * @return {[type]} [description]
     */
    openSettingPopup() {
      this.$store.dispatch('showSettingView');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/frame/components/FrameMenu.vue